import {de} from './de';
import {en} from './en';

export const messages = {
  en,
  de,
};
